import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

/**
 * @deprecated
 */
export const BorderlessChip = styled(Chip)({ border: 'none' });
